import { type EmblaCarouselType } from 'embla-carousel';
import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';

import styles from './listing-detail-carousel-counter.module.scss';

interface UseSelectedSnapDisplayType {
  selectedSnap: number
  snapCount: number
}

export const useSelectedSnapDisplay = (
  emblaApi: EmblaCarouselType | undefined,
): UseSelectedSnapDisplayType => {
  const [selectedSnap,
    setSelectedSnap] = useState(0);
  const [snapCount,
    setSnapCount] = useState(0);

  const updateScrollSnapState = useCallback((api: EmblaCarouselType) => {
    setSnapCount(api.scrollSnapList().length);
    setSelectedSnap(api.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    updateScrollSnapState(emblaApi);
    emblaApi.on('select', updateScrollSnapState);
    emblaApi.on('reInit', updateScrollSnapState);
  }, [emblaApi, updateScrollSnapState]);

  return {
    selectedSnap,
    snapCount,
  };
};

interface PropertyType {
  selectedSnap: number
  snapCount: number
}

export function SelectedSnapDisplay(props: PropertyType) {
  const {
    selectedSnap,
    snapCount,
  } = props;

  return (
    <div className={styles.listingDetailCarouselCounter}>
      {selectedSnap + 1}
      {' '}
      /
      {' '}
      {snapCount}
    </div>
  );
}
